import { useEffect, useState } from 'react';

/**
 * Block 14 «Раскрой» (PR #6, CUT-2.4). Touch-детект через `matchMedia('(pointer: coarse)')`
 * — НЕ по ширине экрана (§IX.X #3, handover §8). На touch → кастомная клавиатура;
 * на desktop → системный numeric-ввод. Реактивен к смене устройства ввода; слушатель
 * снимается при unmount (без утечек).
 */
export function useCoarsePointer(): boolean {
  const [coarse, setCoarse] = useState<boolean>(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
    return window.matchMedia('(pointer: coarse)').matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia('(pointer: coarse)');
    const onChange = (e: MediaQueryListEvent) => setCoarse(e.matches);
    setCoarse(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return coarse;
}
